import { render, staticRenderFns } from "./DiscussDeleteItem.vue?vue&type=template&id=6d21d9e6&"
import script from "./DiscussDeleteItem.vue?vue&type=script&lang=js&"
export * from "./DiscussDeleteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports